export const FILE_SIZE = 1020000;
export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const DEGREES = [0, 90, 180, 270];
export const ERROR_MESSAGE = {
  size: 'File size must be 1MB or under',
  type: 'File must be in .jpg or .png format',
};
